export default __webpack_public_path__ + "static/media/create-supporting2.358f04cb.jpg";